import { InjectionToken } from '@angular/core';

export const PERFECT_SCROLLBAR_CONFIG = new InjectionToken('PERFECT_SCROLLBAR_CONFIG');

export class Geometry {
  public x: number;
  public y: number;

  public w: number;
  public h: number;

  constructor(x: number, y: number, w: number, h: number) {
    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;
  }
}

export class Position {
  public x: number | 'start' | 'end';
  public y: number | 'start' | 'end';

  constructor(x: number | 'start' | 'end', y: number | 'start' | 'end') {
    this.x = x;
    this.y = y;
  }
}

export type PerfectScrollbarEvent = 'psScrollY' | 'psScrollX' | 'psScrollUp' | 'psScrollDown' |
  'psScrollLeft' | 'psScrollRight' | 'psYReachEnd' | 'psYReachStart' | 'psXReachEnd' | 'psXReachStart';

export const PerfectScrollbarEvents: PerfectScrollbarEvent[] = [
  'psScrollY',
  'psScrollX',

  'psScrollUp',
  'psScrollDown',
  'psScrollLeft',
  'psScrollRight',

  'psYReachEnd',
  'psYReachStart',
  'psXReachEnd',
  'psXReachStart'
];

export interface PerfectScrollbarConfigInterface {
  handlers?: string[];

  wheelSpeed?: number;
  swipeEasing?: boolean;

  suppressScrollX?: boolean;
  suppressScrollY?: boolean;

  wheelPropagation?: boolean;
  useBothWheelAxes?: boolean;

  scrollingThreshold?: number;

  minScrollbarLength?: number;
  maxScrollbarLength?: number;

  scrollXMarginOffset?: number;
  scrollYMarginOffset?: number;
}

export class PerfectScrollbarConfig implements PerfectScrollbarConfigInterface {
  // Declared with `declare` so no own properties are created at construction
  // (the original ES5 build only set keys present in the passed config).
  declare public handlers?: string[];

  declare public wheelSpeed?: number;
  declare public swipeEasing?: boolean;

  declare public suppressScrollX?: boolean;
  declare public suppressScrollY?: boolean;

  declare public wheelPropagation?: boolean;
  declare public useBothWheelAxes?: boolean;

  declare public scrollingThreshold?: number;

  declare public minScrollbarLength?: number;
  declare public maxScrollbarLength?: number;

  declare public scrollXMarginOffset?: number;
  declare public scrollYMarginOffset?: number;

  constructor(config: PerfectScrollbarConfigInterface = {}) {
    this.assign(config);
  }

  public assign(config: PerfectScrollbarConfigInterface = {}): void {
    for (const key in config) {
      (this as any)[key] = (config as any)[key];
    }
  }
}
